<template>
  <div>
    <Row :gutter="10">
      <i-col :md="24" :lg="24" style="margin-bottom: 10px;">
        <Card>
          <div style="margin-bottom: 10px;">
            <Row :gutter="10">
              <Col span="6">
                <Card>
                  <p>总职位数</p>
                  <h2 style="color: #2d8cf0;">{{ statistics.total }}</h2>
                </Card>
              </Col>
              <Col span="6">
                <Card>
                  <p>硕士以上职位</p>
                  <h2 style="color: #ff9900;">{{ statistics.masterCount }}</h2>
                </Card>
              </Col>
              <Col span="6">
                <Card>
                  <p>博士以上职位</p>
                  <h2 style="color: #ed4014;">{{ statistics.doctorCount }}</h2>
                </Card>
              </Col>
              <Col span="6">
                <Card>
                  <p>月薪20K+职位</p>
                  <h2 style="color: #19be6b;">{{ statistics.highSalaryCount }}</h2>
                </Card>
              </Col>
            </Row>
          </div>
          <Alert banner closable>页面仅显示学历要求为硕士以上、博士以上或月薪大于20000的岗位</Alert>
          <div class="search-con search-con-top">
            <Input class="search-input" v-model="searchVal" style="padding:5px;" placeholder="输入关键字全局搜索"
                   @on-enter="searchinput"/>

            <Button type="error" class="search-btn" @click="handlerDelete">批量删除</Button>
            <Button type="success" class="search-btn" @click="handlerUp">批量启用</Button>
<!--            <Button type="info" class="search-btn" @click="torem">专区设置</Button>-->
            <!--<Button type="info" class="search-btn" @click="tolg">零工市场</Button>-->
          </div>
          <Spin size="large" fix v-if="spinShow"></Spin>
<!--          <el-tabs style="margin-left: 10px;" v-model="activeName" @tab-click="handleClick">-->
<!--            <el-tab-pane label="全部" name="0"></el-tab-pane>-->
<!--            <el-tab-pane label="推荐" name="1"></el-tab-pane>-->
<!--            <el-tab-pane label="零工市场" name="2"></el-tab-pane>-->
<!--            <el-tab-pane label="劳务派遣" name="3"></el-tab-pane>-->
<!--            <el-tab-pane label="退役军人" name="4"></el-tab-pane>-->
<!--            <el-tab-pane label="残疾人" name="5"></el-tab-pane>-->
<!--            <el-tab-pane label="幸福里社区" name="6"></el-tab-pane>-->
<!--          </el-tabs>-->
          <Table v-loading.fullscreen.lock="fullscreenLoading" height="613" size="small" ref="selection" border
                 :columns="columns" :data="tableData"
                 @on-selection-change="handleSelectChange"></Table>
          <div style="margin: 10px; overflow: hidden">
            <div style="float: left;">
              <Page :total="pageTotal" :current="pageNum" :page-size="pageSize" :page-size-opts=[14,35,50,100]
                    show-sizer show-total @on-change="changePage" @on-page-size-change="handlePageSize">
              </Page>
            </div>
          </div>
          <Modal v-model="modalMap.auditVisible" :title="modalMap.auditTitle" :loading=true :footer-hide=true
                 :mask-closable=false>
<!--            <Alert banner closable>同一职位可编入多个专区，专区打勾即进入，未打勾即移除，提交生效</Alert>-->
            <Form ref="FormItemFormItem" :model="formValidate_audit"  :label-width="100">
              <FormItem
                label="审核说明："
                prop="Jstate"
              >
                 <Input v-model="formValidate_audit.remark" maxlength="500" :rows="6" show-word-limit type="textarea" placeholder="请输入审核内容..." />
              </FormItem>
              <FormItem>
                <Button
                  style="margin-right: 10px;"
                  type="error"
                  @click="handleSubmit_audit(9)"
                >不通过
                </Button>
                <Button
                  type="primary"
                  @click="handleSubmit_audit(1)"
                >通过
                </Button>

              </FormItem>

            </Form>
          </Modal>
          <Modal v-model="modalMap.remVisible" :title="modalMap.remTitle" :loading=true :footer-hide=true
                 :mask-closable=false>
            <Alert banner closable>同一职位可编入多个专区，专区打勾即进入，未打勾即移除，提交生效</Alert>
            <Form ref="formValidate_rem" :model="formValidate_rem"  :label-width="100">
              <FormItem
                label="所选职位："
                prop="jobids"
              >
                {{ formValidate_rem.jobs }}
              </FormItem>

              <FormItem
                label="专区："
                prop="Jabbreviation"
              >
                <el-checkbox :indeterminate="isIndeterminate" v-model="checkAll" @change="handleCheckAllChange">全选</el-checkbox>
                <div style="margin: 15px 0;"></div>
                <el-checkbox-group v-model="checkedrems" @change="handleCheckedCitiesChange">
                  <el-checkbox v-for="item in remtypes" :label="item.id" :key="item.id">{{item.value}}</el-checkbox>
                </el-checkbox-group>
              </FormItem>
              <FormItem>
                <Button
                  type="primary"
                  @click="handleSubmit_inrem('formValidate_rem')"
                >提交
                </Button>

              </FormItem>

            </Form>
          </Modal>
          <Modal v-model="modalMap.modalVisible" :title="modalMap.modalTitle" :loading=true :footer-hide=true
                 :mask-closable=false>
            <Form ref="formValidate_job" :model="formValidate_job" :rules="ruleValidate" :label-width="100">
              <FormItem
                label="职位名称"
                prop="Jobname"
              >
                <Input
                  v-model="formValidate_job.Jobname"
                  placeholder="请输入"
                ></Input>

              </FormItem>

              <FormItem
                label="职位类别"
                prop="Jabbreviation"
              >
                <el-cascader
                  v-model="formValidate_job.Jabbreviation"
                  placeholder="请选择"
                  :options="JabbreviationList"
                  filterable
                  clearable></el-cascader>
              </FormItem>

              <FormItem
                label="职位描述"
                prop="Jdescribe"
              >
                <Input
                  type="textarea"
                  v-model="formValidate_job.Jdescribe"
                  placeholder="请输入"
                ></Input>
              </FormItem>

              <FormItem
                label="招聘人数"
                prop="Jnum"
              >

                <Input
                  v-model="formValidate_job.Jnum"
                  placeholder="请输入"
                ></Input>
              </FormItem>
              <FormItem label="工作经验" prop="Jexperience">
                <el-select
                  v-model="formValidate_job.Jexperience"
                  filterable

                  default-first-option
                  placeholder="请选择">
                  <el-option
                    v-for="item in jobJexperienceList"
                    :key="item.value"
                    :label="item.meaning"
                    :value="item.value">
                  </el-option>
                </el-select>
              </FormItem>
              <FormItem label="学历" prop="Jeducation">
                <el-select
                  v-model="formValidate_job.Jeducation"
                  filterable

                  default-first-option
                  placeholder="请选择">
                  <el-option
                    v-for="item in jobJeducationList"
                    :key="item.value"
                    :label="item.meaning"
                    :value="item.value">
                  </el-option>
                </el-select>

              </FormItem>
              <FormItem label="薪资" prop="Jsalary_type">
                <el-select
                  v-model="formValidate_job.Jsalary_type"
                  filterable
                  default-first-option
                  placeholder="请选择">
                  <el-option
                    v-for="item in jobJsalarytypeList"
                    :key="item.value"
                    :label="item.meaning"
                    :value="parseInt(item.value)">
                  </el-option>
                </el-select>
                <el-checkbox v-model="formValidate_job.Jsalary_number_type" true-label=1 false-label=0 label="区间金额" border></el-checkbox>
              </FormItem>
              <FormItem
                v-if = "formValidate_job.Jsalary_type!=0"
                label="数额"
                prop="Jsalary_number"
              >
                <InputNumber
                  :style="formValidate_job.Jsalary_number_type == 1?'':'width: 50%'"
                  :max="1000000"
                  :min="0"
                  @input="changnumber"
                  :step="0.1"
                  v-model="formValidate_job.Jsalary_number"
                  :formatter="value => (`$ ${value}`) .replace(/\B(?=(\d{3})+(?!\d))/g, ',')"
                  :parser="value => value.replace(/\$\s?|(,*)/g, '')" />
                {{ formValidate_job.Jsalary_number_type == 1? '-' : '' }}
                <InputNumber
                  v-if="formValidate_job.Jsalary_number_type == 1"
                  @input="changnumber"
                  :max="1000000"
                  :min="0"
                  :step="0.1"
                  :formatter="value => (`$ ${value}`) .replace(/\B(?=(\d{3})+(?!\d))/g, ',')"
                  :parser="value => value.replace(/\$\s?|(,*)/g, '')"
                  v-model="formValidate_job.Jsalary_number_end"/>{{getsalarytype(formValidate_job.Jsalary_type)}}
              </FormItem>
<!--              <FormItem label="性别" prop="Jsex">-->
<!--                <el-select-->
<!--                  v-model="formValidate_job.Jsex"-->
<!--                  filterable-->

<!--                  default-first-option-->
<!--                  placeholder="请选择">-->
<!--                  <el-option-->
<!--                    v-for="item in jobJsexList"-->
<!--                    :key="item.value"-->
<!--                    :label="item.meaning"-->
<!--                    :value="item.value">-->
<!--                  </el-option>-->
<!--                </el-select>-->
<!--              </FormItem>-->
              <FormItem label="年龄" prop="Jage">
                <InputNumber
                  :max="99"
                  :min="0"
                  v-model="formValidate_job.Jage_s"/> 至
                <InputNumber
                  :max="99"
                  :min="0"
                  v-model="formValidate_job.Jage_e"/>

              </FormItem>
              <FormItem label="婚姻" prop="Jmarriage">
                <el-select
                  v-model="formValidate_job.Jmarriage"
                  filterable

                  default-first-option
                  placeholder="请选择">
                  <el-option
                    v-for="item in jobJmarriageList"
                    :key="item.value"
                    :label="item.meaning"
                    :value="item.value">
                  </el-option>
                </el-select>
              </FormItem>
              <FormItem
                label="其他要求"
                prop="Jrequirement"
              >
                <Input
                  type="textarea"
                  v-model="formValidate_job.Jrequirement"
                  placeholder="请输入"
                ></Input>
              </FormItem>
              <FormItem
                label="工作地址"
                prop="Jaddress"
              >
                <Input
                  v-model="formValidate_job.Jaddress"
                  placeholder="请输入"
                ></Input>
              </FormItem>
              <FormItem label="开始时间" prop="Jstime">
                <DatePicker  type="datetime" editable v-model="formValidate_job.Jstime" format="yyyy-MM-dd HH:mm:ss" placement="bottom-end" placeholder="请选择开始时间" ></DatePicker>
              </FormItem>

              <FormItem label="结束时间" prop="Jetime">
                <DatePicker  type="datetime" editable v-model="formValidate_job.Jetime" format="yyyy-MM-dd HH:mm:ss" placement="bottom-end" placeholder="请选择结束时间" ></DatePicker>
              </FormItem>

              <FormItem label="类型" prop="Jtype">
                <el-select
                  v-model="formValidate_job.Jtype"
                  filterable

                  default-first-option
                  placeholder="请选择">
                  <el-option
                    v-for="item in jobJtypeList"
                    :key="item.value"
                    :label="item.meaning"
                    :value="item.value">
                  </el-option>
                </el-select>
              </FormItem>
              <FormItem
                label="联系人"
                prop="Jlinkman"
              >
                <Input
                  v-model="formValidate_job.Jlinkman"
                  placeholder="请输入"
                ></Input>
              </FormItem>
              <FormItem
                label="联系电话"
                prop="Jphone"
              >
                <Input
                  v-model="formValidate_job.Jphone"
                  placeholder="请输入"
                ></Input>
              </FormItem>
              <FormItem>
                <Button
                  type="primary"
                  @click="handleSubmit_job('formValidate_job')"
                >提交
                </Button>

              </FormItem>

            </Form>
          </Modal>
        </Card>
      </i-col>
    </Row>

  </div>
</template>

<script>

import {
  getjoblist,
  operationJob,
  changeJob,
  getjobstypeList
} from '@/api/scinfo/scinfo.js'

import { getsysparameterList } from '@/api/system/sys_parameter'
import { operationjob, operationjobaudit, operationjobrem } from '@/api/apply/apply'

// import {Notification} from 'element-ui';

let moment = require('moment')
export default {

  data () {
    return {
      activeName: '0',
      spinShow: false,
      fullscreenLoading: false,
      jobstateList: [],
      jobJexperienceList: [],
      jobJeducationList: [],
      jobJsalarytypeList: [],
      jobJsalaryList: [],
      jobJsexList: [],
      jobJageList: [],
      jobJstateList: [],
      jobJtypeList: [],
      jobJmarriageList: [],
      JabbreviationList: [],
      formValidate_job: {},
      formValidate_rem: {},
      formValidate_audit: {},
      checkAll: false,
      checkedrems: [],
        remtypes: [
          {
            id: 1,
            value: '推荐'
          }
          ],
        isIndeterminate: true,
      searchVal: '',
      tableData: [],
      statistics: {
        total: 0,
        masterCount: 0,
        doctorCount: 0,
        highSalaryCount: 0
      },

      modalMap: {
        modalVisible: false,
        modalTitle: '新建',
        remVisible: false,
        remTitle: '新建',
        auditVisible: false,
        auditTitle: '职位审核'
      },
      tableSelectIdList: [],
      tableSelectList: [],
      editModalData: '',
      pageNum: 1, // 当前页码
      pageTotal: 0, // 数据总数
      pageSize: 14, // 每页条数
      ruleValidate: {
        // admin_user: [{ required: true, message: "请选择管理用户", trigger: "change"}],
        Jobname: [
          {
            required: true,
            message: '名称不能为空',
            trigger: 'blur'
          }
        ],
        Jnum: [
          {
            required: true,
            message: '不能为空',
            trigger: 'blur'
          }
        ],
        Jabbreviation: [
          {
            type: 'array',
            required: true,
            message: '请选择工种',
            trigger: 'blur'
          }
        ],
        Jexperience: [
          {
            required: true,
            message: '请选择工作经验',
            trigger: 'change'
          }
        ],
        Jeducation: [
          {
            required: true,
            message: '请选择学历',
            trigger: 'change'
          }
        ],

        // Jsex: [
        //   {
        //     required: true,
        //     message: "请选择性别要求",
        //     trigger: "change"
        //   }
        // ],

        Jmarriage: [
          {
            required: true,
            message: '请选择婚姻要求',
            trigger: 'change'
          }
        ],
        Jaddress: [
          {
            required: true,
            message: '工作地址不能为空',
            trigger: 'blur'
          }
        ],
        // Jstime: [
        //   {
        //     required: true,
        //     type: "date",
        //     message: "请选择开始时间",
        //     trigger: "change"
        //   }
        // ],
        // Jetime: [
        //   {
        //     required: true,
        //     type: "date",
        //     message: "请选择结束时间",
        //     trigger: "change"
        //   }
        // ],
        Jtype: [
          {
            required: true,
            message: '请选择职位类型',
            trigger: 'change'
          }
        ],
        Jphone: [
          {
            required: true,
            message: '联系电话不能为空',
            trigger: 'blur'
          }
        ],
        Jlinkman: [
          {
            required: true,
            message: '联系人不能为空',
            trigger: 'blur'
          }
        ]
      },
      columns: [
        {
          type: 'selection',
          key: 'id',
          width: 60,
          fixed: 'left',
          align: 'center'
        },

        {
          title: '职位名称',
          key: 'Jobname',
          align: 'center',
          tooltip: 'true',
          fixed: 'left',
          sortable: true,
          width: 180
        },
        {
          title: '单位名称',
          key: 'Cname',
          align: 'center',
          tooltip: 'true',
          fixed: 'left',
          sortable: true,
          width: 250,
          render: (h, params) => {
            const style = params.row.Job_Company.Flag == 1 ? { color: 'red', fontWeight: 'bold' } : {}
            return h('div', { style }, params.row.Cname)
          }
        },
        {
          title: '人数',
          key: 'Jnum',
          align: 'center',
          tooltip: 'true',
          sortable: true,
          width: 80
        },
        // {
        //   title: "性别",
        //   key: "Jsex_CN",
        //   align: "center",
        //   tooltip:"true",
        //   sortable: true,
        //   width: 80,
        // },
        {
          title: '学历',
          key: 'Jeducation_CN',
          align: 'center',
          tooltip: 'true',
          sortable: true,
          width: 120,
          render: (h, params) => {
            const isMaster = this.isMasterOrAbove(params.row.Jeducation_CN)
            const isDoctor = this.isDoctorOrAbove(params.row.Jeducation_CN)
            const style = (isMaster || isDoctor) ? { color: 'red', fontWeight: 'bold' } : {}
            return h('div', { style }, params.row.Jeducation_CN)
          }
        },
        {
          title: '工作经验',
          key: 'Jexperience_CN',
          align: 'center',
          sortable: true,
          tooltip: 'true',
          width: 130
        },

        {
          title: '薪资',
          key: 'Jsalary_CN',
          align: 'center',
          sortable: true,
          tooltip: 'true',
          width: 130,
          render: (h, params) => {
            const isHighSalary = this.isHighSalary(params.row)
            const style = isHighSalary ? { color: 'red', fontWeight: 'bold' } : {}
            return h('div', { style }, params.row.Jsalary_CN)
          }
        },
        {
          title: '岗位要求',
          key: 'Jdescribe',
          align: 'center',
          sortable: true,
          tooltip: 'true',
          width: 230
        },
        {
          title: '开始时间',
          key: 'Jstime',
          align: 'center',
          sortable: true,
          tooltip: 'true',
          width: 160
        },
        {
          title: '结束时间',
          key: 'Jetime',
          align: 'center',
          sortable: true,
          tooltip: 'true',
          width: 160
        },
        {
          title: '更新时间',
          key: 'Updatetime',
          align: 'center',
          sortable: true,
          tooltip: 'true',
          width: 160
        },
        {
          title: '联系人',
          key: 'Jlinkman',
          align: 'center',
          tooltip: 'true',
          sortable: true,
          width: 110
        },
        {
          title: '联系电话',
          key: 'Jphone',
          align: 'center',
          sortable: true,
          tooltip: 'true',
          width: 120
        },
        {
          title: '状态',
          key: 'handle',
          width: 100,
          fixed: 'right',
          align: 'center',
          render: (h, params) => {
            return h('div', [
              h('Tag', { props: { color: params.row.Jstate_col } }, params.row.Jstate_CN)
            ])
          }
        },
        {
          title: '操作',
          key: 'handle',
          fixed: 'right',
          width: 180,
          align: 'center',
          render: (h, params) => {
            if (params.row.Jstate == 1) {
              return h('div', [
                h(
                  'Button',
                  {
                    props: {
                      type: 'primary',
                      size: 'small'
                    },
                    style: {
                      marginRight: '5px'
                    },
                    on: {
                      click: () => {
                        this.editModal(params.row, 'put', '修改')
                      }
                    }
                  },
                  '编辑'
                ),
                h(
                  'Button',
                  {
                    props: {
                      type: 'error',
                      size: 'small'
                    },
                    style: {
                      marginRight: '5px'
                    },
                    on: {
                      click: () => {
                        this.changstate(params.row)
                      }
                    }
                  },
                  '暂停'
                ),
                h(
                  'Button',
                  {
                    props: {
                      type: 'error',
                      size: 'small'
                    },
                    on: {
                      click: () => {
                        this.delData(params)
                      }
                    }
                  },
                  '删除'
                )
              ])
            } else if (params.row.Jstate == 0 || params.row.Jstate == 9) {
                return h('div', [
                  h(
                    'Button',
                    {
                      props: {
                        type: 'primary',
                        size: 'small'
                      },
                      style: {
                        marginRight: '5px'
                      },
                      on: {
                        click: () => {
                          this.editModal(params.row, 'put', '修改')
                        }
                      }
                    },
                    '编辑'
                  ),
                  h(
                    'Button',
                    {
                      props: {
                        type: 'info',
                        size: 'small'
                      },
                      style: {
                        marginRight: '5px'
                      },
                      on: {
                        click: () => {
                          this.auditModal(params.row)
                        }
                      }
                    },
                    '审核'
                  ),
                  h(
                    'Button',
                    {
                      props: {
                        type: 'error',
                        size: 'small'
                      },
                      on: {
                        click: () => {
                          this.delData(params)
                        }
                      }
                    },
                    '删除'
                  )
                ])
            } else {
              return h('div', [
                h(
                  'Button',
                  {
                    props: {
                      type: 'primary',
                      size: 'small'
                    },
                    style: {
                      marginRight: '5px'
                    },
                    on: {
                      click: () => {
                        this.editModal(params.row, 'put', '修改')
                      }
                    }
                  },
                  '编辑'
                ),
                h(
                  'Button',
                  {
                    props: {
                      type: 'success',
                      size: 'small'
                    },
                    style: {
                      marginRight: '5px'
                    },
                    on: {
                      click: () => {
                        this.changstate(params.row)
                      }
                    }
                  },
                  '启用'
                ),

                h(
                  'Button',
                  {
                    props: {
                      type: 'error',
                      size: 'small'
                    },
                    on: {
                      click: () => {
                        this.delData(params)
                      }
                    }
                  },
                  '删除'
                )
              ])
            }
          }
        }
      ]
    }
  },
  methods: {

    // 获取TagTree

    getjoblist (key, value) {
      this.spinShow = true
      // if (this.activeName != '0'){
      //   value = this.activeName + '|1'
      // }
      value = 'alarm'

      getjoblist(this.pageNum, this.pageSize, key, value).then(res => {
        if (res.data.code === 0) {
          this.tableData = this.filterJobsByConditions(res.data.data)
          // this.tableData = res.data.data
          this.pageTotal = this.tableData.length
          this.calculateStatistics()
        } else {
          this.$Message.error(`${res.data.msg}`)
        }
        this.spinShow = false
      })
    },

    filterJobsByConditions (jobs) {
      return jobs.filter(job => {
        const isMaster = this.isMasterOrAbove(job.Jeducation_CN)
        const isDoctor = this.isDoctorOrAbove(job.Jeducation_CN)
        const isHighSalary = this.isHighSalary(job)
        return isMaster || isDoctor || isHighSalary
      })
    },

    isMasterOrAbove (education) {
      const masterEducations = ['硕士', '博士']
      return masterEducations.some(level => education && education.toString().includes(level))
    },

    isDoctorOrAbove (education) {
      const doctorEducations = ['博士']
      return doctorEducations.some(level => education && education.toString().includes(level))
    },

    isHighSalary (job) {
      if (job.Jsalary_type === 1) { // 月薪
        const minSalary = job.Jsalary_number || 0
        return minSalary >= 20000
      } else if (job.Jsalary_type === 4) { // 年薪
        const minSalary = job.Jsalary_number || 0
        return minSalary >= 2400000
      }
      return false
    },

    calculateStatistics () {
      this.statistics.total = this.tableData.length
      this.statistics.masterCount = this.tableData.filter(job => this.isMasterOrAbove(job.Jeducation_CN)).length
      this.statistics.doctorCount = this.tableData.filter(job => this.isDoctorOrAbove(job.Jeducation_CN)).length
      this.statistics.highSalaryCount = this.tableData.filter(job => this.isHighSalary(job)).length
    },

    handleRemove (index) {
      this.formValidate.args_items[index].status = 0
    },

handleClick (tab, event) {
        this.tableSelectIdList = []
        this.tableSelectList = []
           if (this.searchVal) {
              this.getjoblist(this.searchVal)
            } else {
              this.getjoblist()
            }
      },

    handleSubmit_audit (audit) {
      setTimeout(() => {
        this.formValidate_audit.Jaudit = audit
            operationjobaudit(this.formValidate_audit, 'POST').then(res => {
              if (res.data.code === 0) {
                this.$Message.success(`${res.data.msg}`)
                if (this.searchVal) {
                  this.getjoblist(this.searchVal)
                } else {
                  this.getjoblist()
                }
                this.modalMap.auditVisible = false
              } else {
                this.$Message.error(`${res.data.msg}`)
              }
            })
          }, 1000)
    },
    handleSubmit_inrem () {
setTimeout(() => {
  this.formValidate_rem.checkedrems = this.checkedrems
            operationjobrem(this.formValidate_rem, 'POST').then(res => {
              if (res.data.code === 0) {
                this.$Message.success(`${res.data.msg}`)
                if (this.searchVal) {
                  this.getjoblist(this.searchVal)
                } else {
                  this.getjoblist()
                }
                this.modalMap.remVisible = false
              } else {
                this.$Message.error(`${res.data.msg}`)
              }
            })
          }, 1000)
    },
    // table 选中的ID
    handleSelectChange (val) {
      let SelectIdList = []
      let SelectjobnameList = []
      val.forEach(item => {
        SelectIdList.push(item.Id)
        SelectjobnameList.push(item.Jobname)
      })
      this.tableSelectList = SelectjobnameList
      this.tableSelectIdList = SelectIdList
    },

    closeModal () {
      this.dialog.show = false
    },
    getjobspapamsList () {
      getsysparameterList('job_info', 'Jsalary_type').then(res => {
        if (res.data.code === 0) {
          this.jobJsalarytypeList = res.data.data
        } else {
          this.$Message.error(`${res.data.msg}`)
        }
      })
      getsysparameterList('job_info', 'Jexperience').then(res => {
        if (res.data.code === 0) {
          this.jobJexperienceList = res.data.data
        } else {
          this.$Message.error(`${res.data.msg}`)
        }
      })
      getsysparameterList('job_info', 'Jeducation').then(res => {
        if (res.data.code === 0) {
          this.jobJeducationList = res.data.data
        } else {
          this.$Message.error(`${res.data.msg}`)
        }
      })
      getsysparameterList('job_info', 'Jsalary').then(res => {
        if (res.data.code === 0) {
          this.jobJsalaryList = res.data.data
        } else {
          this.$Message.error(`${res.data.msg}`)
        }
      })
      getsysparameterList('job_info', 'Jsex').then(res => {
        if (res.data.code === 0) {
          this.jobJsexList = res.data.data
        } else {
          this.$Message.error(`${res.data.msg}`)
        }
      })
      getsysparameterList('job_info', 'Jage').then(res => {
        if (res.data.code === 0) {
          this.jobJageList = res.data.data
        } else {
          this.$Message.error(`${res.data.msg}`)
        }
      })
      getsysparameterList('job_info', 'Jmarriage').then(res => {
        if (res.data.code === 0) {
          this.jobJmarriageList = res.data.data
        } else {
          this.$Message.error(`${res.data.msg}`)
        }
      })
      getsysparameterList('job_info', 'Jtype').then(res => {
        if (res.data.code === 0) {
          this.jobJtypeList = res.data.data
        } else {
          this.$Message.error(`${res.data.msg}`)
        }
      })
    },
    getjobstypeList (value, level) {
      getjobstypeList(value, level).then(res => {
        if (res.data.code === 0) {
          this.JabbreviationList = res.data.data
        } else {
          this.$Message.error(`${res.data.msg}`)
        }
      })
    },
    changstate (paramsRow) {
      let params = {
        'Id': paramsRow.Id,
        'Jstate': paramsRow.Jstate
      }
      setTimeout(() => {
        changeJob(params, 'PUT').then(res => {
          if (res.data.code === 0) {
            this.$Message.success(`${res.data.msg}`)
            if (this.searchVal) {
              this.getjoblist(this.searchVal)
            } else {
              this.getjoblist()
            }
          } else {
            this.$Message.error(`${res.data.msg}`)
          }
        })
      }, 1000)
    },
    auditModal (paramsRow) {
      this.modalMap.auditVisible = true
      this.modalMap.auditTitle = '审核职位：' + paramsRow.Jobname
      if (paramsRow && paramsRow.Id) {
        this.formValidate_audit = {
          Id: paramsRow.Id,
          Jobname: paramsRow.Jobname
        }
      }
    },
    editModal (paramsRow, meth, mtitle) {
      this.modalMap.modalVisible = true
      this.modalMap.modalTitle = mtitle
      this.editModalData = meth
      // this.getjobspapamsList();
      // this.getjobstypeList();
      var day2 = new Date()
      day2.setTime(day2.getTime())
      var s2 = day2.getFullYear() + '-' + (day2.getMonth() + 1) + '-' + day2.getDate() + ' ' + day2.getHours() + ':' + day2.getMinutes() + ':' + day2.getSeconds()
      if (paramsRow && paramsRow.Id) {
        this.formValidate_job = {
          Id: paramsRow.Id,
          Jobname: paramsRow.Jobname,
          Jabbreviation: paramsRow.Jabbreviation,
          Jdescribe: paramsRow.Jdescribe,
          Jnum: paramsRow.Jnum,
          Jexperience: paramsRow.Jexperience,
          Jeducation: paramsRow.Jeducation,
          Jsalary_type: paramsRow.Jsalary_type,
          Jsalary_number_type: paramsRow.Jsalary_number_type,
          Jsalary_number: paramsRow.Jsalary_number,
          Jsalary_number_end: paramsRow.Jsalary_number_end,
          Jsex: paramsRow.Jsex,
          Jage_s: paramsRow.Jage_s,
          Jage_e: paramsRow.Jage_e,
          Jrequirement: paramsRow.Jrequirement,
          Jaddress: paramsRow.Jaddress,
          Jstate: paramsRow.Jstate,
          Jstime: paramsRow.Jstime,
          Jetime: paramsRow.Jetime,
          Jtype: paramsRow.Jtype,
          Jlinkman: paramsRow.Jlinkman,
          Jphone: paramsRow.Jphone,
          Jmarriage: paramsRow.Jmarriage,
          Juid: paramsRow.Juid,
          Jcid: paramsRow.Jcid,
          Jsuit: paramsRow.Jsuit

        }
        if (paramsRow.Jsalary_number_type == 1) {
          this.formValidate_job.Jsalary_number_type = true
        } else {
          this.formValidate_job.Jsalary_number_type = false
        }
      }
    },
    changnumber () {
      if (this.formValidate_job.Jsalary_number_end < this.formValidate_job.Jsalary_number) {
        this.formValidate_job.Jsalary_number_end = this.formValidate_job.Jsalary_number
      }
    },
    handleCheckAllChange (val) {
      // console.log(val)
        this.checkedrems = val ? [1, 2, 3, 4, 5] : []
        this.isIndeterminate = false
      },
      handleCheckedCitiesChange (value) {
      console.log(value)
        let checkedCount = value.length
        this.checkAll = checkedCount === this.remtypes.length
        this.isIndeterminate = checkedCount > 0 && checkedCount < this.remtypes.length
      },
    handleSubmit_job (value) {
      this.$refs[value].validate((valid) => {
        if (valid) {
          this.formValidate_job.Jstime = moment(this.formValidate_job.Jstime).utcOffset(480).format('YYYY-MM-DD HH:mm:ss')
          this.formValidate_job.Jetime = moment(this.formValidate_job.Jetime).utcOffset(480).format('YYYY-MM-DD HH:mm:ss')
          if (this.formValidate_job.Jsuit.length > 0) {
            this.formValidate_job.Jrecommend = '3|1'
          }

          setTimeout(() => {
            if (this.editModalData == 'post' && this.formValidate_job.Jsuit.length > 0) {
              this.formValidate_job.Jrecommend = '0010'
            }
            operationjob(this.formValidate_job, this.editModalData).then(res => {
              if (res.data.code === 0) {
                this.$Message.success(`${res.data.msg}`)
                if (this.searchVal) {
                  this.getjoblist(this.searchVal)
                } else {
                  this.getjoblist()
                }
                this.modalMap.modalVisible = false
              } else {
                this.$Message.error(`${res.data.msg}`)
              }
            })
          }, 1000)
          // this.$Message.success('Success!');
        } else {
          this.$Message.error('请输入完整信息')
        }
      })
    },

    handleSubmit (value) {
      this.$refs[value].validate((valid) => {
        if (valid) {
          setTimeout(() => {
            this.formValidate.Jstime = moment(this.formValidate.Jstime).utcOffset(480).format('YYYY-MM-DD HH:mm:ss')
            this.formValidate.Jetime = moment(this.formValidate.Jetime).utcOffset(480).format('YYYY-MM-DD HH:mm:ss')
            operationJob(this.formValidate, this.editModalData).then(res => {
              if (res.data.code === 0) {
                this.$Message.success(`${res.data.msg}`)

                if (this.searchVal) {
                  this.getjoblist(this.searchVal)
                } else {
                  this.getjoblist()
                }

                this.modalMap.modalVisible = false
              } else {
                this.$Message.error(`${res.data.msg}`)
              }
            })
          }, 1000)
          // this.$Message.success('Success!');
        } else {
          this.$Message.error('缺少必要参数')
        }
      })
    },

    handleReset (name) {
      this.$refs[name].resetFields()
    },

    handlerDelete () {
      // console.log(this.tableSelectIdList.length)
      if (this.tableSelectIdList.length > 0) {
        if (confirm(`确定要批量删除选中设备 `)) {
          operationJob({ 'id_list': this.tableSelectIdList }, 'delete').then(
            res => {
              if (res.data.code === 0) {
                this.$Message.success(`${res.data.msg}`)
                this.getjoblist(this.searchVal)
              } else {
                this.$Message.error(`${res.data.msg}`)
              }
            })
        }
      } else {
        this.$Message.info(`你总要选中点什么吧`)
      }
    },

    // 删除
    delData (params) {
      if (confirm(`确定要删除 ${params.row.Jobname}`)) {
        // console.log(params.row.id)
        operationJob(
          {
            'id': params.row.Id
          },
          'delete'
        ).then(res => {
          if (res.data.code === 0) {
            this.$Message.success(`${res.data.msg}`)
            this.tableData.splice(params.index, 1)
          } else {
            this.$Message.error(`${res.data.msg}`)
          }
        })
      }
    },

    handleSearch () {
      this.getjoblist(this.searchVal)
    },
    // 点击节点
    // 翻页
    changePage (value) {
      this.pageNum = value
      if (this.searchVal) {
        this.getjoblist(this.searchVal)
      } else {
        this.getjoblist()
      }
    },
    // 切换分页
    handlePageSize (value) {
      this.pageSize = value
      this.pageNum = 1
      if (this.searchVal) {
        this.getjoblist(this.searchVal)
      } else {
        this.getjoblist()
      }
    },
    torem () {
      if (this.tableSelectIdList.length > 0) {
        this.modalMap.remVisible = true
        this.modalMap.remTitle = '职位选入专区'
        this.checkedrems = []
        if (this.activeName != '0') {
          this.checkedrems = [parseInt(this.activeName)]
        }
        this.formValidate_rem.jobs = this.tableSelectList
        this.formValidate_rem.jobids = this.tableSelectIdList
      } else {
        this.$Message.info(`你总要选中点什么吧`)
      }
    },
    handlerUp () {
      // console.log(this.tableSelectIdList.length)
      if (this.tableSelectIdList.length > 0) {
        if (confirm(`确定要批量启用这些职位 `)) {
          changeJob({ 'id_list': this.tableSelectIdList }, 'delete').then(
            res => {
              if (res.data.code === 0) {
                this.$Message.success(`${res.data.msg}`)
                if (this.searchVal) {
                  this.getjoblist(this.searchVal)
                } else {
                  this.getjoblist()
                }
              } else {
                this.$Message.error(`${res.data.msg}`)
              }
            })
        }
      } else {
        this.$Message.info(`你总要选中点什么吧`)
      }
    },
    getsalarytype (stype) {
      if (stype == 1) {
        return '元/月'
      } else if (stype == 2) {
        return '元/日'
      } else if (stype == 2) {
        return '元/月'
      } else if (stype == 3) {
        return '元/小时'
      } else if (stype == 4) {
        return '元/年'
      } else if (stype == 5) {
        return '元/件'
      } else {
        return ''
      }
    },
    searchinput () {
      if (this.searchVal) {
        this.getjoblist(this.searchVal)
      } else {
        this.getjoblist()
      }
    }
  },

  watch: {
    searchVal (val) {
      this.searchVal = val
      // this.getServerList(this.searchVal)
    }
  },
  mounted () {
    this.getjobspapamsList()
    this.getjobstypeList()
    this.getjoblist()
  }
}

</script>

<style lang="less" scoped>
.search-con {
  padding: 10px 0;

  .search {
    &-col {
      display: inline-block;
      width: 200px;
    }

    &-input {
      display: inline-block;
      width: 200px;
      margin-left: 2px;
    }

    &-btn {
      margin-left: 2px;
    }
  }
}
</style>
